import React, { useState, useRef,useEffect } from "react";
import nervousbox from './../../../images/nervousbox.png'
import nerveplusbox from './../../../images/nerveplusbox.png'
import nerveprobox from './../../../images/nerveprobox.png'
import nexdbox from './../../../images/nexdbox.png'
import artistdots1 from './../../../images/artistdots1.png'
import nerveverticaltxt from './../../../images/nerveverticaltxt.png'
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

function NervePlansPage(){
    const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
      })


      const handleResize = () => {
        // console.log(window.innerWidth)
        setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
        });
      }

      useEffect(() => {
        window.addEventListener("resize", handleResize, false);
      }, []);
    
    return (
        <div style={{width:'100vw'}}>

        
        {/* ******************************************** */}


        {/* DESKTOP VIEW */}

        {
            dimensions.width >= 1024 &&
            <div style={{width:'100%',backgroundColor:'#050505',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'5.93em',paddingBottom:'5.93em',position:'relative'}}>
                <img src={nerveverticaltxt} style={{zIndex:'1',position:'absolute',top:'0em',right:'10%'}}/>
                <div style={{width:'73.89%',display:'flex',flexDirection:'row',alignSelf:'center',alignItems:'center',justifyContent:'center',zIndex:'2'}}>

                    <div style={{display:'flex',flexDirection:'column',marginRight:'5.37em'}}>
                        <img src={nervousbox} style={{height:'20em',maxWidth:'444px'}}/>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">N3RVOUS</div>
                               
                        </div>

                        <div className="NervePlansDesc">For the dreamers and explorers, our Free tier lets you dip your toes into the N3RVE ecosystem without breaking the bank. Perfect for artists who want to explore, experiment, and get a feel for what our platform can do. It’s your sandbox to play, learn, and create with no strings attached. Ready to test the waters?</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                        <img src={nerveplusbox} style={{height:'20em',maxWidth:'444px'}}/>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">N3RVE +</div>
                               
                        </div>

                        <div className="NervePlansDesc">N3RVE+ is where things get serious. This middle-tier package is designed for artists ready to grow their reach, build their audience, and unlock advanced features that will elevate their game. Think of it as the perfect mix of power and flexibility—tailored tools to take your music career to the next level. Ready to make some noise?</div>
                    </div>

                </div>

                <div style={{width:'73.89%',display:'flex',flexDirection:'row',alignSelf:'center',alignItems:'center',justifyContent:'center'}}>

                    <div style={{display:'flex',flexDirection:'column',marginRight:'5.37em'}}>
                        <img src={nerveprobox} style={{height:'20em',maxWidth:'444px'}}/>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">N3RVE PRO</div>
                            
                        </div>

                        <div className="NervePlansDesc">For the seasoned professionals who want it all, the Pro tier is your one-stop shop for success. You’ll get access to our full suite of advanced tools, priority support, and industry connections to streamline your workflow and keep your momentum going. This tier is for the serious, dedicated artists who are ready to own their craft and make their mark. Let’s get to work.</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                        <div style={{position:'relative'}}>
                            <img src={nexdbox} style={{height:'20em',maxWidth:'444px'}}/>
                                <div style={{textAlign:'right',position:'absolute',top:'1.5em',left:'0%',display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.9em',marginBottom:'0.2em',width:'wrap'}}>By</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.2em',marginBottom:'0.2em'}}>Invitation</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.6em',marginBottom:'0.2em'}}>Only</div>
                                </div>
                            </div>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">NEXD</div>
                                <div className="InviteOnlyHeader">INVITE ONLY</div>
                            
                        </div>

                        <div className="NervePlansDesc">Reserved for the industry titans and top-tier artists, our invite-only tier is an exclusive experience for those operating on the global stage. Tailored for major artists and enterprises, this top-shelf package provides bespoke solutions, VIP support, and unique opportunities to collaborate and scale your career like never before. Welcome to the big leagues—where the sky’s the limit.</div>
                    </div>

                    </div>

                
            </div>
        }




        {/* /****************************************************************************** */}



        {/* /** TABLET VIEW */}
        {
             dimensions.width >= 768 && dimensions.width <1024 &&
             <div style={{width:'100%',backgroundColor:'#050505',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'5.93em',paddingBottom:'5.93em',position:'relative'}}>
                <img src={nerveverticaltxt} style={{zIndex:'1',position:'absolute',top:'0em',right:'10%'}}/>
                <div style={{width:'98%',display:'flex',flexDirection:'row',alignSelf:'center',alignItems:'center',justifyContent:'center',zIndex:'2'}}>

                    <div style={{display:'flex',flexDirection:'column',marginRight:'1.37em'}}>
                        <img src={nervousbox} style={{height:'20em',maxWidth:'100%'}}/>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">N3RVOUS</div>
                                
                        </div>

                        <div className="NervePlansDesc">For the dreamers and explorers, our Free tier lets you dip your toes into the N3RVE ecosystem without breaking the bank. Perfect for artists who want to explore, experiment, and get a feel for what our platform can do. It’s your sandbox to play, learn, and create with no strings attached. Ready to test the waters?</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                        <img src={nerveplusbox} style={{height:'20em',maxWidth:'100%'}}/>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">N3RVE +</div>
                                
                        </div>

                        <div className="NervePlansDesc">N3RVE+ is where things get serious. This middle-tier package is designed for artists ready to grow their reach, build their audience, and unlock advanced features that will elevate their game. Think of it as the perfect mix of power and flexibility—tailored tools to take your music career to the next level. Ready to make some noise?</div>
                    </div>

                </div>

                <div style={{width:'98%',display:'flex',flexDirection:'row',alignSelf:'center',alignItems:'center',justifyContent:'center'}}>

                    <div style={{display:'flex',flexDirection:'column',marginRight:'1.37em'}}>
                        <img src={nerveprobox} style={{height:'20em',maxWidth:'100%'}}/>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">N3RVE PRO</div>
                            
                        </div>

                        <div className="NervePlansDesc">For the seasoned professionals who want it all, the Pro tier is your one-stop shop for success. You’ll get access to our full suite of advanced tools, priority support, and industry connections to streamline your workflow and keep your momentum going. This tier is for the serious, dedicated artists who are ready to own their craft and make their mark. Let’s get to work.</div>
                    </div>

                    <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                        <div style={{position:'relative'}}>
                            <img src={nexdbox} style={{height:'20em',maxWidth:'100%'}}/>
                                <div style={{textAlign:'right',position:'absolute',top:'1.5em',left:'1%',display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.9em',marginBottom:'0.2em'}}>By</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.1em',marginBottom:'0.2em'}}>Invitation</div>
                                    <div className='NEXDPlanInvitationtxt' style={{fontSize:'1rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'1em',marginBottom:'0.2em'}}>Only</div>
                                </div>
                            </div>

                        <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                                <div className="NervePlansHeader">NEXD</div>
                                <div className="InviteOnlyHeader">INVITE ONLY</div>
                            
                        </div>

                        <div className="NervePlansDesc">Reserved for the industry titans and top-tier artists, our invite-only tier is an exclusive experience for those operating on the global stage. Tailored for major artists and enterprises, this top-shelf package provides bespoke solutions, VIP support, and unique opportunities to collaborate and scale your career like never before. Welcome to the big leagues—where the sky’s the limit.</div>
                    </div>

                    </div>

             
            </div>
        }


        {/* /****************************************************************************** */ }


        {/* /** MOBILE VIEW */ }
        {
             dimensions.width <768  &&
             <div style={{width:'100%',backgroundColor:'#050505',display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center',paddingTop:'5.93em',paddingBottom:'5.93em',position:'relative'}}>
             <img src={nerveverticaltxt} style={{zIndex:'1',position:'absolute',top:'0em',right:'10%'}}/>
             <div style={{width:'98%',display:'flex',flexDirection:'column',alignSelf:'center',alignItems:'center',justifyContent:'center',zIndex:'2'}}>

                 <div style={{display:'flex',flexDirection:'column'}}>
                     <img src={nervousbox} style={{height:'20em',maxWidth:'444px'}}/>

                     <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                             <div className="NervePlansHeader">N3RVOUS</div>
                            
                     </div>

                     <div className="NervePlansDesc">For the dreamers and explorers, our Free tier lets you dip your toes into the N3RVE ecosystem without breaking the bank. Perfect for artists who want to explore, experiment, and get a feel for what our platform can do. It’s your sandbox to play, learn, and create with no strings attached. Ready to test the waters?</div>
                 </div>

                 <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                     <img src={nerveplusbox} style={{height:'20em',maxWidth:'444px'}}/>

                     <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                             <div className="NervePlansHeader">N3RVE +</div>
                            
                     </div>

                     <div className="NervePlansDesc">N3RVE+ is where things get serious. This middle-tier package is designed for artists ready to grow their reach, build their audience, and unlock advanced features that will elevate their game. Think of it as the perfect mix of power and flexibility—tailored tools to take your music career to the next level. Ready to make some noise?</div>
                 </div>

             </div>

             <div style={{width:'98%',display:'flex',flexDirection:'column',alignSelf:'center',alignItems:'center',justifyContent:'center'}}>

                 <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                     <img src={nerveprobox} style={{height:'20em',maxWidth:'444px'}}/>

                     <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                             <div className="NervePlansHeader">N3RVE PRO</div>
                         
                     </div>

                     <div className="NervePlansDesc">For the seasoned professionals who want it all, the Pro tier is your one-stop shop for success. You’ll get access to our full suite of advanced tools, priority support, and industry connections to streamline your workflow and keep your momentum going. This tier is for the serious, dedicated artists who are ready to own their craft and make their mark. Let’s get to work.</div>
                 </div>

                 <div style={{display:'flex',flexDirection:'column',marginTop:'2em'}}>
                     <div style={{position:'relative'}}>
                         <img src={nexdbox} style={{height:'20em',maxWidth:'444px'}}/>
                             <div style={{textAlign:'right',position:'absolute',top:'1.5em',left:'0%',display:'flex',flexDirection:'column',alignItems:'flex-end'}}>
                                 <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.9em',marginBottom:'0.2em',width:'wrap'}}>By</div>
                                 <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.3em',marginBottom:'0.2em'}}>Invitation</div>
                                 <div className='NEXDPlanInvitationtxt' style={{fontSize:'1.125rem',letterSpacing:'1px',backgroundColor:'#6100FF',color:'#FFFFFF',paddingLeft:'0.4em',marginBottom:'0.2em'}}>Only</div>
                             </div>
                         </div>

                     <div style={{display:'flex',flexDirection:'column',backgroundColor:'#18222B',width:'70%',marginTop:'-2em',clipPath:'polygon(30% 0%, 90% 0, 100% 45%, 100% 70%, 100% 100%, 8% 100%, 0 64%, 0 0)',maxWidth:'309px',height:'7.18em',overflow:'visible',zIndex:'1'}}>
                             <div className="NervePlansHeader">NEXD</div>
                             <div className="InviteOnlyHeader">INVITE ONLY</div>
                         
                     </div>

                     <div className="NervePlansDesc">Reserved for the industry titans and top-tier artists, our invite-only tier is an exclusive experience for those operating on the global stage. Tailored for major artists and enterprises, this top-shelf package provides bespoke solutions, VIP support, and unique opportunities to collaborate and scale your career like never before. Welcome to the big leagues—where the sky’s the limit.</div>
                 </div>

                 </div>

             
         </div>
        }

       

        </div>
       
    );
}

export default NervePlansPage;